export const tags = [
  "jnct-rubrics-manager",
  "jnct-rubrics-manager-content",
  "jnct-rubrics-manager-project-list",
  "jnct-rubrics-manager-project-actions",
  "jnct-rubric-preview",
  "jnct-rubric-form",
  "jnct-rubrics-edit-modal",
  "jnct-rubrics-library-table",
] as const;
